import { render, staticRenderFns } from "./ProjectListItem.vue?vue&type=template&id=3960e828&scoped=true&"
import script from "./ProjectListItem.vue?vue&type=script&lang=js&"
export * from "./ProjectListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListItem.vue?vue&type=style&index=0&id=3960e828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960e828",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VTooltip})
